<template>
  <div class="container mt-3">
    <div class="mt-3">
      <h3 class="title mb-3">공지사항</h3>
    </div>
    <h5 class="mt-4">Company : {{ companyName }}</h5>
    <h5>플랫폼명 : {{ platfomrName }}</h5>
    <div class="mt-3 carrot-box p-3">
      <div class="mb-3">
        <div class="txt-right mt-3">
          <b-button variant="primary" class="search-button mr-5px" @click="movePage(`/company/companyInquiry/add?sugangIdx=${searchObj.sugangIdx}`)">글쓰기</b-button>
        </div>
      </div>
      <Table ref="table2" :isCheckBox="false" :tabledata="tableData" :id="'table2'" :loading="tableLoading">
        <!--########################### Body Custom ###########################-->
        <template #BodyrowNum="{ row }">
          <span>{{ row.contentsTypeName !== '해당없음' ? row.contentsTypeName : row.rowNum }}</span>
        </template>
        <template #Bodytitle="{ row }">
          <span class="hyperlink" @click="movePage(`/company/companyInquiry/${row.idx}?sugangIdx=${searchObj.sugangIdx}&idx=${row.idx}`)">{{ row.title }}</span>
        </template>
      </Table>

      <div class="mt-3" v-show="!tableLoading">
        <Paging :totaldata="1" :pagingdata="5" :pagingrange="5" :setPage="setPage" @onPagingEvent="onMovePageing"></Paging>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from '@vue/reactivity';
import { useRouter, useRoute } from 'vue-router';
import { sugangNoticeListApi } from '@/api/integrateapi/index';
import { onMounted } from '@vue/runtime-core';
export default {
  setup() {
    //data
    const router = useRouter();
    const route = useRoute();
    const tableLoading = ref(false);
    const setPage = ref(1);
    const pagingTotal = ref(1);
    const searchObj = reactive({
      sugangIdx: -1,
      pageNum: 1,
      pageSize: 50,
    });
    const tableData = reactive({
      head: [
        {
          headkey: 'rowNum',
          colname: '번호',
        },
        {
          headkey: 'title',
          colname: '제목',
        },
        {
          headkey: 'createDate',
          colname: '작성일자',
        },
        {
          headkey: 'writer',
          colname: '작성자',
        },
        {
          headkey: 'viewCnt',
          colname: '조회수',
        },
      ],
      body: [],
    });

    const platfomrName = ref('');
    const companyName = ref('');
    //func
    const onMovePageing = pagenumber => {
      console.log(pagenumber);
    };
    const movePage = path => {
      router.push(path);
    };

    const getNoticeList = () => {
      console.log(searchObj);
      tableLoading.value = true;
      sugangNoticeListApi(searchObj)
        .then(resp => {
          const { success, data: respData } = resp.data;
          if (success) {
            const { list, total } = respData;
            tableData.body = list;
            pagingTotal.value = total;
          } else {
            tableData.body = [];
            pagingTotal.value = 1;
          }
        })
        .catch(error => {
          if (error.response) {
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {
          tableLoading.value = false;
        });
    };

    onMounted(() => {
      const { sugangIdx, platformName: pltName, companyName: cpName } = route.query;

      platfomrName.value = pltName;
      companyName.value = cpName;
      searchObj.sugangIdx = Number(sugangIdx);
      getNoticeList();
    });
    return {
      tableData,
      setPage,
      pagingTotal,
      tableLoading,
      searchObj,
      platfomrName,
      companyName,
      onMovePageing,
      movePage,
    };
  },
};
</script>

<style lang="scss">
#table2 {
  #rowNum {
    width: 8%;
  }
  #title {
    width: 27%;
  }

  #createDate {
    width: 25%;
  }
  #writer {
    width: 25%;
  }
  #viewCnt {
    width: 10%;
  }
}
.mr-5px {
  margin-right: 5px !important;
}
</style>
